import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CompleteRegistrationComponent } from "./complete-registration.component";

export const routes: Routes = [
    {
        path: ":id",
        component: CompleteRegistrationComponent,
        children: [
            {
                path: ":id",
                component: CompleteRegistrationComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CompleteRegistrationRoutingModule {}
